import { render, staticRenderFns } from "./pathToPush.vue?vue&type=template&id=93ba4be6&scoped=true"
import script from "./pathToPush.vue?vue&type=script&lang=js"
export * from "./pathToPush.vue?vue&type=script&lang=js"
import style0 from "./pathToPush.vue?vue&type=style&index=0&id=93ba4be6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ba4be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93ba4be6')) {
      api.createRecord('93ba4be6', component.options)
    } else {
      api.reload('93ba4be6', component.options)
    }
    module.hot.accept("./pathToPush.vue?vue&type=template&id=93ba4be6&scoped=true", function () {
      api.rerender('93ba4be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/pathToPush.vue"
export default component.exports